import { render, staticRenderFns } from "./BoxBatteryConfirmation.vue?vue&type=template&id=46de04bf&scoped=true&"
import script from "./BoxBatteryConfirmation.vue?vue&type=script&lang=ts&"
export * from "./BoxBatteryConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./BoxBatteryConfirmation.vue?vue&type=style&index=0&id=46de04bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46de04bf",
  null
  
)

export default component.exports